var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-page',{attrs:{"page-title":"Vendors","page-icon":"mdi-account-multiple-outline","collection-name":"vendor","items-per-page":20,"add-dialog-title":"Add Vendor","is-filter":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }